module.exports = __webpack_public_path__ + "static/media/tShirt.10e5c9dc.svg";